<!-- =========================================================================================
    File Name: MailItem.vue
    Description: Mail Item - Displays mail item
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <vx-card class="card-main custom-item" @click.stop="openDetail(data)">
    <div class="flex justify-between flex-wrap">
        <!-- <div class="subandhat" v-if="displaySubjectField">
          {{ getSubjectName(data.subjects) }} - {{ hatName }}
        </div> -->
        <div class="subandhat">
          {{ hatName }}
        </div>
          <template v-if="!isAuthenticated">
            <div class="item-date" v-if="!isReport && canDisplayDateField">{{ formatDate(data.dt_publish, { dateStyle: "short" }) }}</div>
            <div class="item-date" v-if="isReport && canDisplayDateField">{{ formatFullDate(data.dt_report, {dateStyle: "short"}) }}</div>
          </template>
          <template v-else>
            <div class="item-date" v-if="!isReport && canDisplayDateField">{{ formatDate(data.dt_publish, { dateStyle: "short" }) }}</div>
            <div class="item-date" v-if="isReport && canDisplayDateField">{{ formatFullDate(data.dt_report, {dateStyle: "short"}) }}</div>
          </template>
    </div>
    <div class="content-field">
      <!-- <div class="card-text-title mb-2 card-title">{{title | truncateclamp(60)}}</div> -->
      <div class="card-text-title card-title">
        {{ getTitle }}
      </div>
      <!-- <div class="img-back"> -->
      <div>
        <img class="card-img" :src="thumbPath" />
        <!-- <template v-if="thumbPath">
        </template>
        <template v-else>
          <div class="card-img-empty"></div>
        </template> -->
      </div>
    </div>
    <div class="autorline flex author-mosaic mb-2">
      <author-info class="author cursor-pointer w-full flex author-high"  :displayNickname="true" :author="data.author"
        @open-author="$emit('open-author', $event)"></author-info>
    </div>
    <div class="flex justify-between flex-wrap">
      <span>
        <!-- <dropdown-user-info
          :size="dropdownSize"
          :avatarUrl="data.author.image_path"
          :username="data.author.name"
          :resume="data.author.resume"
          :isDesktop="isDesktop"
          :isCardView="true"
        >
        </dropdown-user-info>  -->

        <div class="badges-card">
          <div class="badge live" v-if="data.inLive" @click.stop="onFilter('inLive', true)">
            <div class="badge-wrap">
              <span class="badge-icon badge-view">
                <svg height="14" viewBox="0 0 14 14" width="14" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M7 2.333c2.577 0 4.667 2.09 4.667 4.667S9.577 11.667 7 11.667 2.333 9.577 2.333 7 4.423 2.333 7 2.333zm0 1.05c-1.997 0-3.617 1.62-3.617 3.617 0 1.997 1.62 3.617 3.617 3.617 1.997 0 3.617-1.62 3.617-3.617 0-1.997-1.62-3.617-3.617-3.617z">
                  </path>
                </svg><span class="badge-icon-inner"><svg aria-hidden="true" focusable="false" viewbox="0 0 14 14">
                    <path
                      d="M7 9.567c1.418 0 2.567-1.15 2.567-2.567 0-1.418-1.15-2.567-2.567-2.567-1.418 0-2.567 1.15-2.567 2.567 0 1.418 1.15 2.567 2.567 2.567z">
                    </path>
                  </svg>
                </span>
              </span>
              <span class="badge-text">{{ $t('BADGES').InLive }}</span>
            </div>
          </div>
          <div class="badge" v-if="isImportant(data) && !data.inLive" @click.stop="onFilter('important', true)">
            <div class="badge-wrap"> <span class="badge-text">{{ $t('BADGES').Important }}</span></div>
          </div>
          <div class="badge" v-if="data.exclusive" @click.stop="onFilter('exclusive', true)">
            <div class="badge-wrap"> <span class="badge-text">{{ $t('BADGES').Exclusive }}</span></div>
          </div>
          <div class="badge disclosure-announcement-badge" v-if="isDisclosureAnnouncement"
            @click.stop="onFilter('disclosureAnnouncement', true)">
            <div class="badge-wrap"> <span class="badge-text">{{ $t("BADGES").Announcement }}</span></div>
          </div>
          <div class="badge disclosure-invite-badge" v-if="isDisclosureInvite"
            @click.stop="onFilter('disclosureInvite', true)">
            <div class="badge-wrap"> <span class="badge-text">{{ $t("BADGES").Invite }}</span></div>
          </div>
          <!-- <vs-chip class="cursor-pointer filter-chip exclusive-chip" v-if="data.exclusive">{{$t('BADGES').Exclusive}}</vs-chip>
          <vs-chip class="cursor-pointer filter-chip important-chip" v-if="isImportant(data) && !data.inLive">{{$t('BADGES').Important}}</vs-chip> -->
        </div>
      </span>
      <div class="card-icons flex">
        <action-icons-field 
          :data="data" 
          :isAuthenticated="isAuthenticated" 
          :isDesktop="isDesktop"
          :isItemNews="isItemNews"
          :canDisplayPreview="true"
          :iconReferencePreview="false"
          @addPlaylist="addPlaylist"
          @playMultimedia="playMultimedia"
          @onDownloadFile="onDownloadDocument"
          @open-exclusive-content="$emit('open-exclusive-content')"
          @save-schedule-news="$emit('save-schedule-news', data)"
          @openDetail="openDetail">
        </action-icons-field>
      </div>
    </div>
  
  </vx-card>
</template>

<script>
import DropdownUserInfo from "../widgets/dropdown-user-info/DropdownUserInfo.vue";
import { CONTENT } from "../../../enums/enum-content";
import Popper from "vue-popperjs";
import "vue-popperjs/dist/vue-popper.css";
import generalHelper from '../../../helpers/general-helper';
import translateFieldHelper from '../../../helpers/translate-field-helper';
import convertDatetimeHelper from '../../../helpers/convert-datetime-helper';
import AppConstants from '../../../appConstants';
import InformativePreviewData from './InformativePreviewData.vue';
import formatFieldHelper from '../../../helpers/format-field-helper';
import AuthorInfo from '../../../layouts/components/customizer/AuthorInfo.vue';
import ActionIconsField from '../../../layouts/components/customizer/ActionIconsField.vue';
// import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    isDesktop: {
      type: Boolean,
      required: true,
    },
    contentId: {
      require: true,
    },
    currentCommodity: {
      require: true,
    },
    isAuthenticated: {
      require: true
    },
  },
  data() {
    let dSize;
    if (this.isDesktop) {
      dSize = "20px";
    } else {
      dSize = "30px";
    }
    return {
      dropdownSize: dSize,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.5
      },
      thumbPath: '',
    };
  },
  watch: {

  },
  computed: {
    canDisplayDateField() {
      return (
        this.data.newsContent.findIndex(
          item =>
            item.code != CONTENT.CONSULTING_COURSES
        ) >= 0
      );
    },
    isReport() {
      return (
        this.data.newsContent.findIndex(
          item =>
            item.code == CONTENT.INFORMATIVE ||
            item.code == CONTENT.EXPORTS ||
            item.code == CONTENT.STATISTIC
        ) >= 0
      );
    },
    isDisclosureAnnouncement() {
      return (this.data.disclosureType == AppConstants.DISCLOSURE_TYPE_ENUM.ANNOUNCEMENT);
    },
    isDisclosureInvite() {
      return (this.data.disclosureType == AppConstants.DISCLOSURE_TYPE_ENUM.INVITE);
    },
    getTitle() {
      if (!this.data && !this.data.newsContent) return '';
      if (this.data.newsContent[0].code == CONTENT.STATISTIC ||
        this.data.newsContent[0].code == CONTENT.EXPORTS ||
        this.data.newsContent[0].code == CONTENT.INFORMATIVE) {
        return translateFieldHelper.getTranslateField('name', this.data.reportType);
      }
      return this.data.content.title.data;
    },
    AppActiveUser() {
      return this.$store.state.AppActiveUser;
    },
    canDisplayPreview() {
      return (this.data.content.abstract || this.data.content.text) && this.isDesktop;
    },
    detailContent() {
      if (this.data.content.body) {
        return this.linkify(this.data.content.body.data);
      }
      return "";
    },
    hatName() {
      if (this.data.hat[0]) {
        return this.data.hat[0].name.toUpperCase();
      }
      return this.data.newsContent[0][`name${this.$i18n.locale}`];
    },
    displayReportDate() {
      return (
        this.data.newsContent[0].code != CONTENT.CONSULTING_COURSES &&
        this.data.newsContent[0].code != CONTENT.CONSULTING_SPEECHES
      );
    },
    hasPeriodicity() {
      if (!this.data.periodicity) return false;
      return !!this.data.periodicity.name;
    },
    hasCharacteristic() {
      if (!this.data.characteristic) return false;
      return !!this.data.characteristic.name;
    },
    hasMultimedia() {
      return (
        !!this.data.soundcloud ||
        !!this.data.youtubeId ||
        !!this.data.audio ||
        !!this.data.spotify
      );
    },
    hasDocument() {
      return !!this.data.document;
    },
    // displayHatField() {
    //   return (
    //     this.data.newsContent[0].code == CONTENT.NEWS ||
    //     this.data.newsContent[0].code == CONTENT.CONSULTING_SAFRAS_TV ||
    //     this.data.newsContent[0].code == CONTENT.CONSULTING_SAFRAS_PODCAST
    //   );
    // displaySubjectField() {
    //   return (
    //     this.currentCommodity.id == 0
    //   );
    // },
    isItemNews() {
      return this.data.newsContent[0].code == CONTENT.NEWS;
    },
    hasTextToSpeech() {
      if ((this.data.content.abstract || this.data.content.text) && !this.hasDocument && this.isDesktop) {
        return `${this.getTitle} ${this.data.content.abstract.data} ${this.data.content.text.data}`;
      }
      return false;
    },
    canSpeechText() {
      return generalHelper.canSpeechText(this.data, this.isDesktop);
    },
    canAddPlaylist() {
      return (
        !!this.data.youtubeId ||
        !!this.data.audio ||
        // this.hasTextToSpeech ||
        !!this.data.soundcloud ||
        !!this.data.spotify
      ) && this.isAuthenticated;
    },
    badgeTypeClass() {
      if (this.data.document) return "attach-document";
      if (this.data.audio) return "audio";
      if (this.data.youtubeId) return "video";
      if (this.data.soundcloud) return "podcast";
      if (this.data.spotify) return "podcast";
      return "";
    },
  },
  methods: {
    onFilter(field, val) {
      this.$emit("filter", { field: field, value: val });
    },
    formatFullDate(val, obj) {
      return convertDatetimeHelper.formatFullDate(val, obj);
    },
    formatDate(val, obj) {
      return convertDatetimeHelper.formatDate(val, obj);
    },


    async getThumbPath() {
      // this.thumbPath = require("@/assets/images/informative/placeholder115.svg");
      if (this.data && this.data.thumb) {
        const exist = await generalHelper.checkImageExist(this.data.thumb.image_path);
        if (exist) {
          this.thumbPath = this.data.thumb.image_path;
          return;
        }
      }
      let originCode = formatFieldHelper.getOriginCode(this.AppActiveUser);
      if (this.currentCommodity.id && this.currentCommodity.id > 0) {
        this.thumbPath = require(`../../../assets/images/commodity/${originCode}/${this.currentCommodity.id}.png`);
      } else {
        this.thumbPath = require(`../../../assets/images/commodity/${originCode}/${this.data.subjects[0].code}.png`);
      }
    },
    onDownloadDocument(data) {
      this.$emit("onDownloadFile", data);
    },
    getSubjectName(subjects) {
      return translateFieldHelper.getSubjectName(subjects, this.currentCommodity);
    },
    getSubjectIcon(subjects) {
      if (this.currentCommodity.id) {
        const sub = subjects.find(
          (item) => item.code == this.currentCommodity.id
        );
        if (sub) {
          return sub.icon;
        }
      }
      return subjects[0].icon;
    },
    playMultimedia({data, isTextSpeech}) {
      if (
        this.hasYoutube() ||
        this.hasAudio(data) ||
        this.hasSoundCloud(data) ||
        this.canSpeechText ||
        this.hasSpotify(data)
      ) {
        this.$emit("playMultimedia", {
          data: data,
          isTextSpeech: isTextSpeech,
        });
      } else {
        this.openDetail(data);
      }
    },
    featherIconSize() {
      if (this.isDesktop) {
        return "h-4 w-4";
      } else {
        return "h-6 w-6";
      }
    },
    getIconCard() {
      if (this.hasYoutube()) {
        return "VideoIcon";
      } else if (
        this.hasAudio() ||
        this.hasSoundCloud() ||
        this.hasSpotify()
      ) {
        return "MicIcon";
      } else if (this.hasDocument) {
        return "PaperclipIcon";
      } else {
        return null;
      }
    },
    hasAudio() {
      return !!this.data.audio;
    },
    hasYoutube() {
      if (!this.data) return false;
      return !!this.data.youtubeId;
    },
    hasSpotify() {
      return !!this.data.spotify;
    },
    hasSoundCloud() {
      return !!this.data.soundcloud;
    },
    hasImageOrThumbUrl(reportDetail) {
      return !!reportDetail.image || !!reportDetail.thumb;
    },
    isImportant(value) {
      return value.importance > 0;
    },
    addPlaylist(reportDetail) {
      // alert(`add playlist: ${reportDetail._id}`);
      // console.log(`add playlist: ${reportDetail._id}`);
      this.$store.dispatch("insertItemPlaylist", reportDetail);
    },
    openDetail(reportDetail) {
      this.$emit("openDetailParent", reportDetail);
    },
    imageUrl(value) {
      if (value.thumb) {
        return value.thumb.image_path;
      }
      if (value.image) {
        return value.image.image_path;
      }

      return require("@/assets/images/informative/placeholder115.svg");
    },
  },
  async created() {
    // console.log('[canAddPlaylist]', this.canAddPlaylist);
    await this.getThumbPath();
  },
  components: {
    popper: Popper,
    DropdownUserInfo,
    InformativePreviewData,
    AuthorInfo,
    ActionIconsField,
    // VuePerfectScrollbar
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 600px) {
  body {
    background-color: lightblue;
  }
}

@media only screen and (max-width: 600px) {
  .content-field {
    white-space: pre-line;
    height: auto;
    margin: 0 !important;

    img {
      transition: 0.35s;
      margin-top: 5px;
      margin-bottom: 10px;
      width: 100%;
      height: 115px;
      object-fit: cover;
      object-position: 0 50%;
    }
  }
}

@media (min-width: 600px) {
  .content-field {
    white-space: pre-line;
    height: auto;
    margin: 0 !important;

    .filter-chip {
      font-weight: 400;
      font-size: 8px;

      height: 14px;
      min-height: 0;
      align-items: center;
    }

    .item-date {
      margin-bottom: 2px;
      font-size: 10px !important;
      margin-top: 0 !important;
    }

    .card-text-title {
      // font-size: 11px;
    }

    .card-text-commodity {
      text-transform: none !important;
      font-size: 12px;
    }

    img {
      transition: 0.35s;
      margin-top: 5px;
      margin-bottom: 10px;
      width: 100%;
      height: 115px;
      object-fit: cover;
      object-position: 0 50%;
    }
  }
}

.card-title {
  font-size: 1.1rem;
  font-weight: 600;
  line-height: px;
  /* height: 34px; */
  display: table-cell;
  vertical-align: middle;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.card-text-commodity {
  text-transform: none !important;
}

.card-main {
  border-radius: 0;
  background-color: #fff;
  border: 1px solid #d6d6d6;
  cursor: pointer;
  margin-top: 5px;
  margin-bottom: 5px;
  margin-left: 5px;
  margin-right: 5px;
  min-height: 225px;
}

.card-main:hover {
  background-color: #efefef !important;
  transform: translateY(-5px);
  box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.3);
}

.theme-dark .card-main:hover {
  box-shadow: 0 4px 25px 0 rgba(120, 120, 120, 0.2);
}

.theme-dark .card-main {
  border-radius: 0;
  background-color: #353e45;
  border: 1px solid #4d5762;
  cursor: pointer;
}

.theme-dark .card-main:hover {
  background-color: #4d5762 !important;
}

.item-avatar {
  margin-top: -6px;
  /*position: absolute;*/
  /*margin-left: 10px;*/
  float: left;
}

.card-chips {
  // min-width: 150px;
  margin-top: 2px;
  display: flex;
}

.item-date {
  margin-bottom: 2px;
  margin-top: 0 !important;
}

.item-card-chapeu {
  color: #ababab;
  font-size: 10px;
  margin-top: 2px;
  font-weight: 500;
  text-align: right;
}</style>
